
































import { Component, Prop, Vue } from 'vue-property-decorator';
import { BModal } from 'bootstrap-vue';
import { Form } from '@/models/Form';
import { ReportElement, Report } from '@/models/ReportElement';

@Component({
    name: 'ModalReportElementDelete',
    components: {
        'b-modal': BModal,
    },
})
export default class ModalFormElementDelete extends Vue {
    updating = false;
    error = '';

    @Prop() element!: ReportElement;
    @Prop() form!: Form;
    @Prop() report!: Report;

    onShow() {
        this.error = '';
    }

    async remove() {
        this.updating = true;
        try {
            const element = await this.$store.dispatch('reportElements/delete', this.element);
            this.$store.commit('reports/removeElement', element);
            this.$bvModal.hide(`modalReportElementDelete-${this.element.id}`);
        } catch (e) {
            this.error = e.toString();
        } finally {
            this.updating = false;
        }
    }
}
